import React from 'react';

import { IBenefit } from 'shared/domain/entities';
import { Button } from 'shared/presentation/components/molecules';
import { ICONS } from 'shared/presentation/constants';
import { useLocale, useToast } from 'shared/presentation/contexts';
import { buildWhatsappLink } from 'shared/presentation/helpers';
import {
  useMicroEvents,
  useCurrencyFormatter,
} from 'shared/presentation/hooks';

import * as S from './styles';

interface IBenefitLinkSectionProps {
  benefit: IBenefit;
  userId: number;
}

const BenefitLinkSection: React.FC<IBenefitLinkSectionProps> = ({
  benefit,
  userId,
}) => {
  const { t } = useLocale('shared');
  const toast = useToast();
  const microEvents = useMicroEvents();
  const formatter = useCurrencyFormatter();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(benefit.recommendation.link);
      toast.success(t('Link successfully copied!'));
      microEvents.register({
        userId,
        event: 'clienteCopiouLinkIndicacao',
      });
    } catch (error) {
      toast.error(t('The link could not be copied Please try again!'));
    }
  };

  const handleShare = () => {
    try {
      const message = t(
        "Our friendship is worth millions and in Vialaser it's worth a discount! 😍%0aWin a {{discount}} discount on the purchase of a hair removal package at Vialaser by subscribing with my link, but remember, this cupon is only valid for purchases up to {{minValue}} %0a%0a{{link}}",
        {
          link: benefit.recommendation.link,
          minValue: formatter.format(benefit.minimumBudgetValue),
          discount: formatter.format(benefit.recommendation.discount.value),
        },
      );

      const link = buildWhatsappLink({
        message: decodeURI(message),
      });

      window.open(link, '_blank');
    } catch (error) {
      toast.error(t('The link could not be shared Please try again!'));
    }
  };

  return (
    <S.Container>
      <input type="text" disabled value={benefit.recommendation.link} />

      <Button
        variant="primary"
        icon={ICONS.COPY}
        iconPosition="right"
        onClick={handleCopy}
      >
        {t('Copy link')}
      </Button>

      <Button
        variant="primary"
        icon={ICONS.WHATSAPP}
        iconPosition="right"
        onClick={handleShare}
      >
        {t('Share your link via Whatsapp')}
      </Button>
    </S.Container>
  );
};

export default BenefitLinkSection;
